var PageMySmartup = (function ($) {

    PageMySmartup = function (options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];
        that.renew_subscription_modal = options['modals']['renew_subscription_modal'];
        that.passengers_drawer_data = options['drawers']['passengers'];
        that.segment_remainders_drawer_data = options['drawers']['segment_remainders'];
        that.luggage_remainders_drawer_data = options['drawers']['luggage_remainders'];

        that.$segment_remainders_drawer_open = that.$wrapper.find('.js-segment-remainders-drawer-open');
        that.$luggage_remainders_drawer_open = that.$wrapper.find('.js-luggage-remainders-drawer-open');
        that.$passengers_drawer_open = that.$wrapper.find('.js-passengers-drawer-open');
        that.$renew_subscription_modal_open = that.$wrapper.find('.js-renew-subscription-modal-open');
        that.$smartup_support_chat_open = that.$wrapper.find('.js-smartup-support-chat-open');
        that.$smartup_support_call_open = that.$wrapper.find('.js-smartup-support-call-open');

        // CONST

        that.classes = {};

        // INIT
        that.init();
    };

    PageMySmartup.prototype.init = function () {
        var that = this;

        that.initRenewSubscriptionModal();
        
        that.initPassengersDrawer();
        that.initSegmentRemaindersDrawer();
        that.initLuggageRemaindersDrawer();
    };

    PageMySmartup.prototype.initRenewSubscriptionModal = function () {
        var that = this;

        that.$renew_subscription_modal_open.on('click', function (e) {
            e.preventDefault();

            $.uiModal({
                html: that.renew_subscription_modal
            });
        });
    };

    PageMySmartup.prototype.initPassengersDrawer = function () {
        var that = this;
        
        that.$passengers_drawer_open.on('click', function (e) {
            e.preventDefault();
            $.uiDrawer({
                position: 'right',
                lock_body_scroll: true,
                header_title: that.passengers_drawer_data['header_title'],
                header_description: that.passengers_drawer_data['header_description'],
                content: $(that.passengers_drawer_data['content']),
                custom_class: 'smartup-passengers',
                onOpen: function ($drawer_wrapper, drawer_instance) {
                    UIInputMask.prototype.initPhoneMask($drawer_wrapper);   
                }
            });
        });
    };

    PageMySmartup.prototype.initSegmentRemaindersDrawer = function () {
        var that = this;

        that.$segment_remainders_drawer_open.on('click', function (e) {
            e.preventDefault();
            $.uiDrawer({
                position: 'right',
                lock_body_scroll: true,
                header_title: that.segment_remainders_drawer_data['header_title'],
                header_description: that.segment_remainders_drawer_data['header_description'],
                content: $(that.segment_remainders_drawer_data['content']),
                custom_class: 'segment-remainders',
                onOpen: function ($drawer_wrapper, drawer_instance) {
                }
            });
        });
    };

    PageMySmartup.prototype.initLuggageRemaindersDrawer = function () {
        var that = this;

        that.$luggage_remainders_drawer_open.on('click', function (e) {
            e.preventDefault();
            $.uiDrawer({
                position: 'right',
                lock_body_scroll: true,
                header_title: that.luggage_remainders_drawer_data['header_title'],
                header_description: that.luggage_remainders_drawer_data['header_description'],
                content: $(that.luggage_remainders_drawer_data['content']),
                custom_class: 'luggage-remainders',
                onOpen: function ($drawer_wrapper, drawer_instance) {
                }
            });
        });
    };

    return PageMySmartup;
})($);